import React, { Component } from 'react'

import FontIcon from '../../../SPRINTA/atoms/FontIcon'

import css from './style.module.css'
export default class AccordionSection extends Component {
    state = {
        active: false
    }

    toogleActive() {
        this.setState(state => ({
            active: !state.active
        }))
    }

    render() {
        return (
            <div className={css.accordionBox}>
                <div className={css.header} onClick={() => this.toogleActive()}>
                    <div className={css.title}>
                        {this.props.title()}
                    </div>

                    <div className={css.icon}>
                        {this.state.active ? (
                            <FontIcon name='up-arrow' />
                        ) : (
                            <FontIcon name='down-arrow' />
                        )}
                    </div>
                </div>
                <div className={css.accordion} style={{ display: this.state.active ? 'block' : 'none' }}> 
                    {this.props.children}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/molecules/AccordionSection/index.js